import { useState } from 'react'
import ExcludeCampaignModal from '../modals/ExcludeCampaignModal'

/**
 * Chip rojo de exclusion de campañas. Click abre modal multi-select.
 * @param {Object} filters - { exclude_campaign_id }
 * @param {Function} updateFilter - (key, value) => void
 * @param {boolean} autoOpen
 * @param {Function} onRemove
 */
export default function ExcludeCampaignChip({ filters, updateFilter, autoOpen = false, onRemove }) {
  const [open, setOpen] = useState(!!autoOpen)
  const selected = filters.exclude_campaign_id || []

  const handleRemove = (e) => {
    e.stopPropagation()
    if (onRemove) onRemove()
  }

  const handleConfirm = (ids) => {
    updateFilter('exclude_campaign_id', ids)
  }

  const label = selected.length === 0
    ? '📢 −Camp (elegir)'
    : `📢 −Camp ${selected.length} campaña${selected.length > 1 ? 's' : ''}`

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        type="button"
        className="group flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full bg-rose-100 dark:bg-rose-900/40 text-rose-800 dark:text-rose-200 hover:bg-rose-200 dark:hover:bg-rose-900/60 transition-colors"
      >
        <span>{label}</span>
        <span
          onClick={handleRemove}
          className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 cursor-pointer"
          role="button"
        >
          ✕
        </span>
      </button>
      {open && (
        <ExcludeCampaignModal
          initialSelected={selected}
          onConfirm={handleConfirm}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
